import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, forkJoin, of, Subject, Subscription } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../../../core/auth';
import { MachineService, MachineTechType, MachineType, ProductService, Shift, ShiftService } from '../../../../../core/plant-configuration';
import { ProductionLineService } from '../../../../../core/plant-configuration/_services/production-line.service';
import { OperatorService } from '../../../../../core/plant-configuration/_services/operator.service';
import { MachineTechTypeService } from '../../../../../core/plant-configuration/_services/machine-tech-type.service';
import { MachineTypeService } from '../../../../../core/plant-configuration/_services/machine-type.service';
import { MachineSensorPortService } from '../../../../../core/plant-configuration/_services/machine-sensor-port.service';
import { BasicDialogService } from '../../../../../core/_base/services/basic-dialog.service';
import { MachineSensorService } from '../../../../../core/plant-configuration/_services/machine-sensor.service';
import * as _ from 'lodash';
@Component({
	selector: 'kt-machines-edit',
	templateUrl: './machines-edit.component.html',
	styleUrls: []
})
export class MachinesEditComponent implements OnInit, OnDestroy, AfterViewInit {
	itemObs = new Subject<any[]>();
	editObs = new Subject<number>();
	addObs = new Subject<number>();
	private itemFormOptions = {
		name: ["", Validators.required],
		iiot_code: ["", Validators.required],
		vel_max: [-1],
		// max_min_no_prod: [0],
		// data_conversion: [1],
		pos: [-1],
		is_production_line: ['t'],
		machine_tech_type_id: ["-1",],
		machine_type_id: ["-1",],
		default_product_id: ["-1",],
		product_list: new FormArray([]),
		shift_id: [-1],
		production_line_id: [-1],
		operator_id: [-1],
		is_last_in_production_line: [false],
		sensor_list: new FormArray([]),
		gps: [false]
		// company_id: ["-1", Validators.required],
	};
	itemForm = this.formBuilder.group(this.itemFormOptions);
	stepList: any[] = [
		{
			icon: "flaticon-settings-1", title: "Parámetros de la máquina", subTitle: "Define parámetros básicos de la máquina", form: [
				[
					{ name: "name", label: "Nombre", type: "text", instructions: "Por favor ingrese el nombre de la máquina" },
					{ name: "iiot_code", label: "Iiot Code", type: "text", instructions: "Por favor ingrese el iiot code de la máquina" },
				],
				[
					{ name: "machine_type_id", label: "Tipo de máquina", type: "list", instructions: "Por favor seleccione el tipo de máquina", optionList: [] },
					{ name: "production_line_id", label: "Linea de producción", type: "list", instructions: "Por favor seleccione una línea de producción", optionList: [] },
				],
				[
						{ name: "machine_tech_type_id", label: "Tipo de tecnología", type: "list", instructions: "Por favor seleccione el tipo de tecnología", optionList: [] },
						{ name: "vel_max", label: "Velocidad máxima", type: "number", instructions: "Por favor ingrese la velocidad máxima" },
					],
					[
						// { name: "data_conversion", label: "Factor de conversión", type: "number", instructions: "Por favor ingrese el factor de conversión" },					
						{ name: "pos", label: "Posición", type: "number", instructions: "Por favor ingrese la posición" },					
					],
					// [
						// 	// { name: "max_min_no_prod", label: "Máximo tiempo muerto", type: "number", instructions: "Ingrese la máxima cantidad de minutos sin operar" },
						// ], 
						[
							{ name: "is_last_in_production_line", label: "Último de la linea", type: "checkbox", value:0},
							{ name: "gps", label: "Lleva GPS", type: "checkbox", value: 0}
						]
					]
				}, {
					icon: "flaticon-calendar-2", title: "Selección de turnos", subTitle: "Define los turnos para el uso de la máquina", form: [
						[
							{ name: "shift_id", listTitle: 'Turnos asignados', label: "Turnos", type: "multiple", optionList: [], selected: [] },
						],
					]
				}, {
					icon: "flaticon2-architecture-and-city", title: "Selección de sensores", subTitle: "Ingrese los sensores", form: [
						[
							{ name: "sensor_list", label: "Sensores", listTitle: "Sensores", type: "table", columnList: [
								{ name: "machine_tech_type_id", label: "Tecnologia", type: "list", optionList: []},
								{ name: "sensor_port_id", label: "Puerto", type: "list", optionList: []},
								{ name: "sensor_id", label: "Sensor", type: "list", optionList: []},
								{ name: "data_conversion", label: "Factor de conversión", type: "text" },
								{ name: "max_min_no_prod", label: "Máximo tiempo muerto", type: "text" },
								{ name: "debounce_s", label: "Muestreo mínimo", type: "text" },
								{ name: "vel_max_s", label: "Velocidad máxima", type: "text" },
								{ name: "f_max_s", label: "Frecuencia máxima (seg)", type: "text" },
								{ name: "f_max_m", label: "Frecuencia máxima (min)", type: "text" },
							], selected: []}, 
						],
					]
				}, {
					icon: "flaticon-interface-1", title: "Productos", subTitle: "Configure los productos", form: [
						[{ name: "default_product_id", label: "Producto por defecto", type: "list", instructions: "Por favor seleccione un producto", optionList: [] }],
						[
							{ name: "product_list", label: "Productos", listTitle: "Productos", type: "table", columnList: [
								{ name: "product_id", label: "Producto", type: "list", optionList: []},
								{ name: "ideal_rate_units_min", label: "Frecuencia ideal", type: "text"},
								{ name: "default_target_units", label: "Producción ideal", type: "text"},
							], selected: []}, 
						],
					]
				}, {
					icon: "flaticon-users-1", title: "Selección de operadores", subTitle: "Asigne operadores a la máquina", form: [
						[
							{ name: "operator_id", listTitle: 'Operadores asignados', label: "Operadores", type: "multiple", optionList: [], selected: [] },
						],
					]
				},
	];

	private subscriptions: Subscription[] = [];
	data: any = {};
	uid: number = -1;
	productList: any[] = [];
	productionLineList: any[] = [];
	shiftList: Shift[] = [];
	operatorList: any[] = [];
	machineTypeList: MachineTechType[] = [];
	machineTechTypeList: MachineType[] = [];
	sensorPortList: any[] = [];
	sensorList: any[] = [];

	constructor(
		private machineService: MachineService,
		private productService: ProductService,
		private shiftService: ShiftService,
		private productionLineService: ProductionLineService,
		private operatorService: OperatorService,
		private machineTechTypeService: MachineTechTypeService,
		private machineTypeService: MachineTypeService,
		private machineSensorPortService: MachineSensorPortService,
		private machineSensorService: MachineSensorService,
		// private companyService: CompanyService,
		private authService: AuthService,
		private formBuilder: FormBuilder,
		private cdr: ChangeDetectorRef,
		private basicDialogService: BasicDialogService
	) { }

	ngOnInit() {
		this.uid = this.authService.getUID();
		this.subscriptions.push(
			of(null).pipe(
				switchMap(() => forkJoin([
					this.productService.getAll(),
					this.productionLineService.getAll(),
					this.shiftService.getAll().pipe(map(shift=>shift.filter(shift=>shift.active==true))),
					this.operatorService.getAll(),
					this.machineTypeService.getAll(),
					this.machineTechTypeService.getAll(),
					this.machineSensorPortService.getAll(),
					this.machineSensorService.getAll()
				]))
			).subscribe(([productList, productionLineList, shiftList, 
					operatorList, machineTypeList, machineTechTypeList,
					sensorPortList, sensorList]) => {
				this.productList = productList;
				this.productionLineList = productionLineList;
				this.shiftList = shiftList;
				console.log('shift list: ', shiftList)
				this.operatorList = operatorList;
				this.machineTechTypeList = machineTechTypeList;
				this.machineTypeList = machineTypeList;
				this.sensorPortList = sensorPortList;
				this.sensorList = sensorList;
				const machineTechTypeInput_ = this.getInput('machine_tech_type_id');
				machineTechTypeInput_.optionList = machineTechTypeList.map(machineTechType=>{
					return {text: machineTechType.name, value: machineTechType.id}
				});

				const sensorListInput = this.getInput('sensor_list');
				const machineTechTypeInput = sensorListInput.columnList.find(col=>col.name == 'machine_tech_type_id');
				machineTechTypeInput.optionList = machineTechTypeList.map(machineTechType=>{
					return {text: machineTechType.name, value: machineTechType.id}
				});
				const sensorPortInput = sensorListInput.columnList.find(col=>col.name == 'sensor_port_id');
				sensorPortInput.optionList = sensorPortList.map(sensorPort=>{
					return {text: sensorPort.name, value: sensorPort.id}
				});
				const sensorInput = sensorListInput.columnList.find(col=>col.name == 'sensor_id');
				sensorInput.optionList = sensorList.map(sensor=>{
					return {text: sensor.name, value: sensor.id}
				});

				const productListInput = this.getInput('product_list');
				const productInput = productListInput.columnList.find(col=>col.name == 'product_id');
				productInput.optionList = productList.map(product=>{
					return {text: product.name, value: product.id}
				});

				const machineTypeInput = this.getInput('machine_type_id');
				machineTypeInput.optionList = machineTypeList.map(machineType => {
					return { text: machineType.name, value: machineType.id }
				});
				const defaultProductInput = this.getInput('default_product_id');
				defaultProductInput.optionList = productList.map(product => {
					return { text: product.name, value: product.id }
				});
				const productLineInput = this.getInput('is_last_in_production_line');
				productLineInput.optionList = [{
					text: 'Ninguna', value: -1
				}].concat(productionLineList.map(productionLine => {
					return { text: productionLine.name, value: productionLine.id }
				}));
				const shiftInput = this.getInput('shift_id');
				shiftInput.optionList = shiftList.map(shift => {
					return { text: shift.name, value: shift.id }
				});
				this.getInput('operator_id').optionList = operatorList.map(operator => {
					return { text: operator.name, value: operator.id }
				});
				console.log("operator list ");console.dir(this.getInput('operator_id').optionList)

				this.data.productList = productList;
				this.data.productionLineList = productionLineList;
				this.data.shiftList = shiftList;
				this.data.operatorList = operatorList;
				this.data.machineTechTypeList = machineTechTypeList;
				this.data.machineTypeList = machineTypeList;
				this.cdr.detectChanges();
			})
		);
	}
	ngAfterViewInit() {

	}
	ngOnDestroy() {
		this.subscriptions.forEach(sub => sub.unsubscribe());
	}

	getInput(field){
		for(let step of this.stepList){
			for(let row of step.form){
			  const input = row.find(input=>input.name == field);
			  if(input){
				  return input;
			  } 
			}
		}
		return null;
	}

	getSensorList(){
		console.dir(this.itemForm.controls.sensor_list.value);
		return this.itemForm.controls.sensor_list.value.map(sensor=>{
			const machineTechType = this.machineTechTypeList.find(machineTechType=>machineTechType.id == sensor.machine_tech_type_id);
			const sensorPort = this.sensorPortList.find(sensorPort=>sensorPort.id == sensor.sensor_port_id);
			const sensor_ = this.sensorList.find(sensor_=>sensor_.id == sensor.sensor_id);
			return {
				machine_tech_type: _.get(machineTechType, 'name', ''),
				sensor_port: _.get(sensorPort, 'name', ''),
				data_conversion: sensor.data_conversion,
				max_min_no_prod: sensor.max_min_no_prod,
				sensor: _.get(sensor_, 'name', ''),
				debounce_s: _.get(sensor, 'debounce_s', -1),
				vel_max_s: _.get(sensor, 'vel_max_s', -1),
				f_max_s: _.get(sensor, 'f_max_s', -1),
				f_max_m: _.get(sensor, 'f_max_m', -1),
			}
		})
	}

	getProductLineRateList(){
		console.dir(this.itemForm.controls.product_list.value);
		return this.itemForm.controls.product_list.value.map(productLineRate=>{
			const product = this.productList.find(product=>product.id == productLineRate.product_id);
			return {
				product: _.get(product, 'name', ''),
				ideal_rate_units_min: productLineRate.ideal_rate_units_min,
				default_target_units: productLineRate.default_target_units,
			}
		})
	}

	onItemLoaded(item) {

		console.log("on item load:", item);

		if(item.Shifts && item.Shifts.length>0)
			this.getInput('shift_id').selected = item.Shifts.map(shift=>`${shift.id}`);
		if(item.Operators && item.Operators.length>0)
			this.getInput('operator_id').selected = item.Operators.map(operator=>`${operator.id}`);
		if(item.is_last_in_production_line){
			const productLineInput = this.getInput('is_last_in_production_line');
			productLineInput.value = item.is_last_in_production_line;
		}
		if(item.gps)
			this.getInput('gps').value = item.gps;
		if(item.Products && item.Products.length>0)
			this.itemForm.controls.default_product_id.patchValue(item.Products[0].id);
		//Sensores
		const sensorTableInput = this.getInput('sensor_list');
		sensorTableInput.selected = item.Machine2Sensors.map(sensor=>{
			return [
				_.get(sensor, 'MachineTechType.name', ''),
				_.get(sensor, 'MachineSensorPort.name', ''),
				_.get(sensor, 'MachineSensor.name', ''),
				sensor.data_conversion, 
				sensor.max_min_no_prod,
				sensor.debounce_s,
				sensor.vel_max_s,
				sensor.f_max_s,
				sensor.f_max_m,
			]
		});
		item.sensor_list = item.Machine2Sensors.map(sensor=>{
			return {
				id: sensor.id,
				machine_tech_type_id: sensor.machine_tech_type_id,
				sensor_port_id: sensor.sensor_port_id,
				sensor_id: sensor.sensor_id,
				data_conversion: sensor.data_conversion,
				max_min_no_prod: sensor.max_min_no_prod,
				debounce_s: sensor.debounce_s,
				vel_max_s: sensor.vel_max_s,
				f_max_s: sensor.f_max_s,
				f_max_m: sensor.f_max_m,
			}
		})
		const sensorFormArray = this.itemForm.controls.sensor_list as FormArray;
		item.Machine2Sensors.forEach(sensor=>{
			const formRow = new FormGroup({});
			formRow.addControl('id', new FormControl(sensor.id, []));
			formRow.addControl('machine_tech_type_id', new FormControl(sensor.machine_tech_type_id, [Validators.required]));
			formRow.addControl('sensor_port_id', new FormControl(sensor.sensor_port_id, [Validators.required]));
			formRow.addControl('sensor_id', new FormControl(sensor.sensor_id, []));
			formRow.addControl('data_conversion', new FormControl(sensor.data_conversion, [Validators.required, Validators.min(1)]));
			formRow.addControl('max_min_no_prod', new FormControl(sensor.max_min_no_prod, [Validators.required, Validators.min(0)]));
			formRow.addControl('debounce_s', new FormControl(sensor.debounce_s, [Validators.required, Validators.min(-1)]))
			formRow.addControl('vel_max_s', new FormControl(sensor.vel_max_s, [Validators.required, Validators.min(-1)]))
			formRow.addControl('f_max_s', new FormControl(sensor.f_max_s, [Validators.required, Validators.min(-1)]))
			formRow.addControl('f_max_m', new FormControl(sensor.f_max_m, [Validators.required, Validators.min(-1)]))
			
			sensorFormArray.push(formRow);
		})
		//Productos
		const productLineRateInput = this.getInput('product_list');
		productLineRateInput.selected = item.ProductLineRates.map(productLineRate=>{
			return [
				_.get(productLineRate, 'Product.name', ''),
				_.get(productLineRate, 'ideal_rate_units_min', ''),
				_.get(productLineRate, 'default_target_units', ''),
			]
		});
		item.product_list = item.ProductLineRates.map(productLineRate=>{
			return {
				product_id: productLineRate.product_id,
				ideal_rate_units_min: productLineRate.ideal_rate_units_min,
				default_target_units: productLineRate.default_target_units,
			}
		})
		const productLineRateFormArray = this.itemForm.controls.product_list as FormArray;
		item.ProductLineRates.forEach(productLineRate=>{
			const formRow = new FormGroup({});
			formRow.addControl('product_id', new FormControl(productLineRate.product_id, [Validators.required]));
			formRow.addControl('ideal_rate_units_min', new FormControl(productLineRate.ideal_rate_units_min, [Validators.required]));
			formRow.addControl('default_target_units', new FormControl(productLineRate.default_target_units, []));			
			productLineRateFormArray.push(formRow);
		})
		this.cdr.detectChanges();
	}

	onChangeTableInputForm(event){
		console.dir(event);
		const formRow = event.event;
		const values = formRow.value;
		const input = event.input;
		
		if(input.name == 'sensor_list'){
			const sensorListInput = this.getInput('sensor_list');
			const sensorInput = sensorListInput.columnList.find(col=>col.name == 'sensor_id');
			let currentSensorId = formRow.controls.sensor_id.value;
			const machineTechTypeId = values.machine_tech_type_id;
			if(currentSensorId == null && sensorInput.optionList.length>0){
				currentSensorId = `${sensorInput.optionList[0].value}`
				formRow.controls.sensor_id.patchValue(currentSensorId, {emitEvent: false});
			}
			console.log(`current sensor id: ${JSON.stringify(currentSensorId)}`)
			console.dir(this.sensorList)
			console.log(JSON.stringify(machineTechTypeId));
			console.log(JSON.stringify(this.sensorList.filter(sensor=>`${sensor.machine_tech_type_id}` == machineTechTypeId).map(sensor=>`${sensor.id}`)))
						
			sensorInput.optionList = this.sensorList
				.filter(sensor=>sensor.machine_tech_type_id == machineTechTypeId)
				.map(sensor=>{
					return {text: sensor.name, value: sensor.id}
				});
			
			
			if(!this.sensorList.filter(sensor=>`${sensor.machine_tech_type_id}` == machineTechTypeId).map(sensor=>`${sensor.id}`).includes(currentSensorId))
				formRow.controls.sensor_id.patchValue(null, {emitEvent: false});
		}
	}

	getItem(itemId: number) {
		this.subscriptions.push(
			of(null).pipe(
				switchMap(() => this.machineService.getById(itemId))
			).subscribe(item => {
				this.onItemLoaded(item);
				this.itemObs.next(item);
			})
		)
	}

	addItem(item: any) {
		item.create_uid = this.uid > 0 ? this.uid : 'null';
		// item.create_date = "now()";
		// if(item.production_line_id == -1)item.production_line_id = null;
		console.dir(item);
		// item.is_installation_contact = 'true';
		// item.active = 'true';
		this.subscriptions.push(
		  of(null).pipe(
		    switchMap(() => this.machineService.add(item))
		  ).subscribe(newId => {
		    this.addObs.next(newId);
		  }, error=>{
			console.dir(error);
			this.basicDialogService.error(error.error);
		  })
		)
	}

	editItem(item: any) {
		item.write_uid = this.uid > 0 ? this.uid : 'null';
		// item.write_date = "now()";
		// if(item.production_line_id == -1)item.production_line_id = null;
		console.dir(item);
		// item.is_installation_contact = 'true';
		this.subscriptions.push(
		  of(null).pipe(
		    switchMap(() => this.machineService.edit(Object.assign({}, item, {
				Machine2Sensors: undefined,
				MachineLastGps: undefined,
				MachineTechType: undefined
			})))
		  ).subscribe(status => {
		    if (status == "success") this.editObs.next(item.id);
		    else this.editObs.next(-1);
		  }, error=>{
			console.dir(error);
			this.basicDialogService.error(error.error);
		  })
		)

	}
}